<template>
  <div
    class="square-button outer "
    :class="isAction ? 'action' : ''"
    @click.stop="handleSquareBtnClick"
  >
    <v-btn class="inner" :disabled="isDisabled">
      <span class="text">{{ text }}</span>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'SquareButton',

  props: {
    isAction: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    handleSquareBtnClick() {
      this.$emit('handleSquareBtnClick');
    },
  },
};
</script>

<style lang="scss" scoped>
.square-button{
  padding: 2px;
  border-radius: 4px;
  .v-btn.inner{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 10px;
    box-shadow: none;
    border-radius: 10px;
    background-color: #f2f3f3;
    .text{
      font-family: $notoSans;
      color: #6c6e75;
      text-transform: initial;
      font-size: 16px;
      font-weight: bold;
    }
  }
  &.action{
    .v-btn.inner{
      background-color: #2fa7d7;
      background: linear-gradient(to right, #0d1f40, #2a4d9c);
      color: white;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      gap: 12px;
      position: relative;
      justify-content: center;
      overflow: hidden;
      .text{
        color: #fff;
      }
    }
  }
}
</style>
